import fs from 'node:fs'
import path from 'node:path'
import { hasConflictMarkers } from '@cli-utils/text.js'
import { getAllTrackedFilePaths } from '@core-engine/snapshots/store/get-all-tracked-file-paths.js'

export function scanConflictPaths(cwd: string): string[] {
  const conflictPaths: string[] = []

  for (const filePath of getAllTrackedFilePaths(cwd)) {
    const fullPath = path.join(cwd, ...filePath.split('/'))
    if (!fs.existsSync(fullPath)) {
      continue
    }

    const content = fs.readFileSync(fullPath, 'utf-8')
    if (hasConflictMarkers(content)) {
      conflictPaths.push(filePath)
    }
  }

  return conflictPaths.sort()
}
